<template>
  <div class="org2" v-loading="loading">
    <div class="subject">
      <h3>研究主题</h3>
      <div class="keywordbox">
        <div v-show="Domainwords.length!==0">
          <h4>{{Domainwords.length}} Research Area</h4>
          <div class="research-area">
            <a
              href
              v-for="(keyword,index) in Domainwords"
              :key="index"
            >{{keyword.name+'('+keyword.value+')'}}</a>
          </div>
        </div>
        <div v-show="keywords.length!==0">
          <h4>{{keywords.length}} Keywords</h4>
          <div class="keywords">
            <a
              href
              v-for="(keyword,index) in keywords"
              :key="index"
            >{{keyword.name+'('+keyword.value+')'}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="region">
      <h3>学科分布</h3>
      <div class="chart-container clearfix">
        <HistogramChart id="histogramChart" :chartData="organizations" height="500px" width="100%" />
        <!-- <area-chart class="area" id="AreaChart" height="500px" width="60%" /> -->
        <!-- <div class="org-area">
          <ul>
            <li v-for="(organization,index) in organizations" :key="index">
              <h4>{{organization.name}}</h4>
              <p>{{organization.value}}合作者分布在{{organization.value}}个机构</p>
            </li>
          </ul>
        </div>-->
      </div>
    </div>
    <div class="resource">
      <div class="chart-container clearfix">
        <pie-chart
          style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
          class="pie"
          id="ENPieChart"
          height="420px"
          width="40%"
          title="外文核心论文学科分布"
          :chart-data="IpieChartData"
          v-loading="loading3"
        />
        <pie-chart
          style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
          class="pie"
          title="中文核心论文学科分布"
          id="CNPatentPieChart"
          height="420px"
          width="50%"
          :chart-data="PpieChartData"
          v-loading="loading4"
        />
        <!-- <PieRes-chart
          style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
          class="piel"
          id="journalPieChart"
          :chartData="journalsData"
          tit="期刊"
          height="420px"
          width="50%"
        />
        <PieRes-chart
          style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
          class="pier"
          id="pressPieChart"
          :chartData="publishData"
          tit="出版社"
          height="420px"
          width="50%"
        />-->
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/components/commonOrg/Common";
import AreaChart from "@/components/Charts/AreaChart";
import PieResChart from "@/components/Charts/PieResChart";
import HistogramChart from "@/components/Charts/HistogramChart";
import PieChart from "@/components/Charts/PieChart";

export default {
  name: "Overview",
  props: {
    allData: Object
  },
  components: {
    Common,
    AreaChart,
    PieResChart,
    HistogramChart,
    PieChart
  },
  watch: {
    allData: {
      deep: true,
      handler() {
        this.setData();
      }
    }
  },
  data() {
    return {
      loading: false,
      Domainwords: [],
      keywords: [],
      organizations: [],
      journalsData: [],
      publishData: [],
      IpieChartData: [],
      PpieChartData: []
    };
  },
  methods: {
    setData() {
      this.Domainwords = this.allData.tops.topDomains;
      this.keywords = this.allData.tops.topKeywords;
      this.organizations = this.allData.tops.topOrganizations;
      this.journalsData = this.allData.tops.topJournals.slice(0, 15);
      this.publishData = this.allData.tops.topPublishers.slice(0, 15);
      this.loading = false;
    }
  },
  mounted() {
    this.loading = true;
    console.log();
    this.PpieChartData = JSON.parse(localStorage.getItem("PpieChartData"));
    this.IpieChartData = JSON.parse(localStorage.getItem("IpieChartData"));
    // setInterval(this.scroll, 1000)
    if (Object.keys(this.allData).length) {
      this.setData();
    }
  }
};
</script>

<style lang="scss">
h3 {
  margin-bottom: 10px;
}
.chart-container {
  margin-bottom: 30px;
  .line {
    float: left;
  }
  .pie {
    float: right;
  }
}
.org2 {
  margin-bottom: 30px;
  .keywordbox {
    h4 {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 5px;
    }
    .research-area,
    .keywords {
      height: 125px;
      overflow-y: scroll;
      margin-bottom: 20px;
      a {
        font-size: 12px;
        display: inline-block;
        padding: 3px 5px;
        background-color: #ccc;
        border-radius: 3px;
        color: #fff;
        margin: 0 10px 5px 0;
      }
    }
  }
}
.region {
  .chart-container {
    .area {
      float: left;
    }
    // .org-area{
    //   float: right;
    //   margin-top: 150px;
    //   ul{
    //     height: 200px;
    //     overflow-y: scroll;
    //     li{
    //       margin-bottom: 10px;
    //       h4{
    //         font-size: 14px;
    //       }
    //       p{
    //         font-size: 12px;
    //       }
    //     }
    //   }
    // }
  }
}
.resource {
  margin-top: 100px;
  .chart-container {
    .piel {
      float: left;
    }
    .pier {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/organization/Orgs/org2.vue